import { useState, useEffect } from "react";
import { local_backend } from "../config";

const useChatThread = () => {
  const [threadId, setThreadId] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const createThread = async () => {
      try {
        // Thread creation is proxied through our backend (which holds the OpenAI
        // key) instead of calling api.openai.com directly from the browser — the
        // direct call was blocked by CORS and exposed the API key client-side.
        const response = await fetch(`${local_backend}OpenAPI/api/assistants/threads`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Failed to create thread");
        }

        const data = await response.json();
        // NOTE: the backend returns HTTP 200 even on failure (ObjectResult wraps
        // GenericResponse), so we must check isSuccess — not just response.ok.
        const succeeded = data?.isSuccess ?? data?.IsSuccess ?? false;
        // GenericResponse.Message carries the thread id on success, or an error
        // string on failure. Be tolerant of either JSON casing.
        const id = data?.Message ?? data?.message;
        if (!succeeded || !id || !String(id).startsWith("thread_")) {
          throw new Error(id || "Failed to create thread");
        }
        setThreadId(id);
      } catch (err) {
        setError(`Failed to initialize chat: ${err.message}`);
      }
    };

    if (!threadId) {
      createThread();
    }
  }, [threadId]);

  return { threadId, error };
};

export default useChatThread;
